<style>
input:focus {
  color: red;
}
</style>
<template>
  <div class="col-lg-9">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <table class="board_table">
          <tr>
            
            <th>제목</th>
            <td colspan="3">
              <input
                type="text"
                class="form-control"
                placeholder="제목을 입력하세요."
                v-model="title"
                style="height: 40px; width: 400px"
              />
            </td>
          </tr> 
          <tr>
            <th>말머리</th>
            <td>
              <select class="hidtype" v-model="addi_data1">
                <option value="공지사항">공지사항</option>
                <option value="학습일기">학습일기</option>
                <option value="미션과제">미션과제</option>
              </select>
            </td>
            <th>학습일</th>
            
            <td>
              <input type="date" class="form-control" v-model="addi_data2" />
            </td>
          </tr>
          <!-- <tr v-if="this.$route.params.board == 'announce'">
            <th>+ 메인홈페이지 노출여부</th>
            <td>
              <input type="checkbox" v-model="addi_data1" />
            </td>
            <th v-if="this.$route.params.board == 'announce'">
              + 학원홈페이지 노출여부
            </th>
            <td>
              <input type="checkbox" v-model="addi_data2" />
            </td>
          </tr>
          <tr v-if="this.$route.params.board == 'announce'">
            <td colspan="4">모두 체크하지 않으면 LMS에만 노출됩니다.</td>
          </tr>-->
          <tr >
            <td colspan="4" style="text-align: left; padding: 20px">
              <SummernoteEditor
                v-model="content"
                @summernoteImageLinkInsert="summernoteImageLinkInsert"
                :config="summernoteConfig"
                v-if="summernoteReady"
                ref="summernote"
              />
            </td>
          </tr> 
        </table>
        <div class="flex_center">
          
            <button class="btn btn-secondary" @click="historyback()">
              취&nbsp;&nbsp;소
            </button>
          <button class="btn btn-danger" @click="addEventArticle()">
            글 올리기
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "summernote/dist/summernote-lite";
import "summernote/dist/summernote-lite.css";
import SummernoteEditor from "vue3-summernote-editor";
import "summernote-file";
import jq from "jquery";

export default {
  components: {
    SummernoteEditor,
  },
  mounted() {
    if (this.$route.params.article) {
      this.creating = false;
      axios
        .get(
          "/articles_event/" +
          this.$route.params.board + "/articles/" +
            this.$route.params.article
        )
        .then((response) => {
          if (response.data.error) {
            alert("게시글을 불러올 수 없습니다.\n" + response.data.error);
          } else {
            this.title = response.data.result.title;
            this.content = response.data.result.content;
            this.addi_data1 = response.data.result.addi_data1;
            this.addi_data2 = response.data.result.addi_data2;
            this.addi_data3 = response.data.result.addi_data3;
            if (this.$route.params.board == "announce") {
              this.addi_data1 = this.addi_data1 == "1";
              this.addi_data2 = this.addi_data2 == "1";
            }
          }
        });
    }

    this.summernoteConfig.callbacks.onFileUpload = (files) => {
      const uploadFile = files[0];
      const formData = new FormData();
      formData.append("userfile", uploadFile);

      axios({
        method: "post",
        url: "https://s.mypathkr.com/upload",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          jq(this.$refs.summernote.elem).summernote(
            "pasteHTML",
            '<a href="' +
              response.data.url +
              '"><i class="bi bi-file-earmark-arrow-down-fill"></i> ' +
              uploadFile.name +
              "</a>"
          );

          //this.changedData.image = response.data.url
        }
      });
    };

    this.summernoteConfig.callbacks.onImageUpload = (files) => {
      const uploadFile = files[0];
      const formData = new FormData();
      formData.append("userfile", uploadFile);

      axios({
        method: "post",
        url: "https://s.mypathkr.com/upload",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          jq(this.$refs.summernote.elem).summernote(
            "editor.insertImage",
            response.data.url
          );

          //this.changedData.image = response.data.url
        }
      });
    };

    this.summernoteReady = true;
  },
  data() {
    return {
      creating: true,
      title: "",
      content: "",
      addi_data1: "",
      addi_data2: "",
      addi_data3: "",
      myValue: "",
      summernoteReady: false,
      summernoteConfig: {
        toolbar: [
          ["style", ["style"]],
          ["font", ["bold", "underline", "clear"]],
          ["fontname", ["fontname"]],
          ["color", ["forecolor", "backcolor"]],
          ["para", ["ul", "ol", "paragraph"]],
          ["table", ["table"]],
          ["insert", ["link", "picture", "video", "file"]],
          ["view", ["codeview"]],
        ],
        callbacks: {
          onFileUpload: function (files) {},
        },
      },
    };
  },
  methods: {
    addthumb() {
      var input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.onchange = (e) => {
        const uploadFile = e.target.files[0];
        const formData = new FormData();
        formData.append("userfile", uploadFile);
        axios({
          method: "post",
          url: "https://s.mypathkr.com/upload",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            //this.editor.commands.clearContent();.
            this.addi_data3 = response.data.url;
            //this.changedData.image = response.data.url
          }
        });
      };
      input.click();
    },
    addEventArticle() {
  
      var data = {
        title: this.title,
        content: this.content,
        addi_data1: this.addi_data1,
        addi_data2: this.addi_data2,
        addi_data3: this.addi_data3,
      };
      var send = axios({
        method: this.creating ? "post" : "patch",
        url:
          "/articles_event/" +
          this.$route.params.board +
          (!this.creating ? "/" + this.$route.params.article : ""),
        data: data,
      });
      send.then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "처리할 수 없습니다 " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          $.notify(
            {
              // options
              message: "처리되었습니다",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );

          this.$router.push(
            this.creating
              ? response.data.id.toString()
              : "../" + response.data.id.toString()
          );
        }
      });
    },
    summernoteChange(newValue) {
      console.log("summernoteChange", newValue);
    },
    summernoteImageLinkInsert(...args) {
      console.log("summernoteImageLinkInsert()", args);
    },
    historyback(){
      this.$router.go(-1);
    },
  },
};
</script>
